module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.f0435382.png";